module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Gb-Hc-Ib-Ja.d63cce27.png";